/**
 * Hard fetch timeout — races any thenable (supabase-js query builders, fetch(),
 * supabase.functions.invoke promises) against a deadline so a hung network or
 * backend call can never leave a page stuck in a permanent loading state.
 *
 * supabase-js builders (PostgrestFilterBuilder) are thenable, so they resolve
 * correctly via Promise.resolve() without any extra wrapping.
 */

/** 5-second deadline for all network/database reads. */
export const FETCH_TIMEOUT_MS = 5000;

export function withTimeout<T>(
  promise: PromiseLike<T>,
  ms: number = FETCH_TIMEOUT_MS,
  label = "request",
): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    let settled = false;

    const timer = setTimeout(() => {
      if (settled) return;
      settled = true;
      reject(new Error(`${label} timed out after ${ms}ms`));
    }, ms);

    Promise.resolve(promise).then(
      (value) => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        resolve(value);
      },
      (err) => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        reject(err);
      },
    );
  });
}